import React from 'react';
import './Footer.css'
const Footer = () => {
    return (
        <div>
            <div className='footer'>
            <h1>CopyRight @Rakib Hasan 2022</h1>
            
        </div>
        </div>
    );
};

export default Footer;